import {Injectable} from '@angular/core';
import {IFractal} from '../interfaces/fractal';
import {IFractalSettings} from '../interfaces/fractal-settings';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FractalService {

  // FIXME Fix this service -> implement.
  public settings: IFractalSettings;
  public fractal: IFractal<IFractalSettings>;
  public settingsSubject: Subject<IFractalSettings>;

  constructor() {
    this.settingsSubject = new BehaviorSubject(null);
  }

  public setFractal(fractal: IFractal<IFractalSettings>, settings: IFractalSettings): void {
    this.fractal = fractal;
    this.settings = settings;

    this.settingsSubject.next(settings);
  }
}
